import { render } from "./ZenventoryLogoIcon.vue?vue&type=template&id=6485cb3c"
import script from "./ZenventoryLogoIcon.vue?vue&type=script&lang=js"
export * from "./ZenventoryLogoIcon.vue?vue&type=script&lang=js"

import "./ZenventoryLogoIcon.vue?vue&type=style&index=0&id=6485cb3c&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__